// import store from "@/store"

export const state = () => ({
  list: [],
  count: 0
})

export const getters = {
  list: (state) => state.list || []
}

export const mutations = {
  set: (state, [key, value]) => (state[key] = value),
  // setList: (state, payload) => state.list = payload,
  createItem(state, payload) {
    state.list = [
      ...state.list,
      {
        ...payload,
        title: JSON.parse(payload.title)
      }
    ]
  },
  updateItem(state, payload) {
    const findIndex = state.list.findIndex((item) => item.id == payload.id)
    if (findIndex !== -1) {
      state.list = [
        ...state.list.slice(0, findIndex),
        payload,
        ...state.list.slice(findIndex + 1)
      ]
    }
  },
  deleteItem(state, payload) {
    const findIndex = state.list.findIndex((item) => item.id == payload)
    if (findIndex != -1) {
      state.list = [
        ...state.list.slice(0, findIndex),
        ...state.list.slice(findIndex + 1)
      ]
    }
  }
}

export const actions = {
  // fetch: () => store.$api.get('/smi/page/list?limit=10&params={}'),
  fetch({ commit }, payload) {
    return this.$api
      .get("/smi/list", {
        params: payload
      })
      .then((res) => {
        if (res && res.data) {
          commit("set", ["list", res.data.results || []])
          commit("set", ["count", res.data.items_count || 0])
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },
  createItemAction({ commit }, payload) {
    return this.$api
      .post("/smi/create", payload)
      .then((res) => {
        // console.log(res);
        commit("createItem", res.data)
        return res
      })
      .catch((err) => {
        console.log(err)
        return err
      })
  },
  updateItemAction({ commit }, payload) {
    return this.$api
      .put("/smi/update/", payload)
      .then((res) => {
        // console.log(res);
        commit("updateItem", res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  },
  deleteItemAction({ commit }, payload) {
    return this.$api
      .delete("/smi/delete/" + payload)
      .then((res) => {
        // console.log(res);
        commit("deleteItem", payload)
        return res
      })
      .catch((err) => {
        console.log(err)
        return err
      })
  }
}
